import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@fontsource-variable/martian-mono'
import '@/styles/globals.css'
// Общие утилиты (.icon-btn/.badge/.divider/.data-table…) — глобально, т.к. их
// используют компоненты вне админ-страниц (диалоги в TopBar).
import '@/styles/table.css'
// Примитивы полей формы (.field*/.input*) — тоже глобально: их используют компоненты
// из разных lazy-чанков (Select, GeositeSelector, списочные редакторы), и привязка к
// чанку TextField оставляла инпуты без стилей на первой загрузке.
import '@/styles/forms.css'
import App from './App'
import { router } from './router'
import { setupPwaAutoUpdate } from '@/lib/pwa'

const rootElement = document.getElementById('root')

if (rootElement === null) {
  throw new Error('Root element #root not found in document')
}

// Регистрация service worker и тихое применение обновлений — до рендера, чтобы подписка на
// маршруты успела встать раньше первой навигации.
setupPwaAutoUpdate(router)

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
